import { createConfig, http } from "@wagmi/core"
import { injected } from "@wagmi/connectors"
import { CHAIN_CONFIG } from "../chain"

const RPC_HTTP = import.meta.env.VITE_RPC_HTTP

export const wagmiConfig = createConfig({
  chains: [CHAIN_CONFIG.viemConfig],
  connectors: [injected()],
  transports: {
    [CHAIN_CONFIG.id]: http(RPC_HTTP),
  },
})
